/* ==========================================================================
   oé · Favoritos propios (reemplaza Swym Wishlist Plus)
   - Guarda los favoritos en el navegador de la clienta (localStorage), sin límite.
   - Corazones: cualquier botón con [data-oe-wish="handle-del-producto"].
   - Contador: cualquier elemento con [data-oe-wish-count].
   - Página: elemento [data-oe-wish-page] (sección "Mis favoritos").
   - Klaviyo: envía el evento "Agregó a Favoritos" cuando la clienta está identificada.
   ========================================================================== */
(function () {
  'use strict';
  if (window.oeWishlist) return;

  var KEY = 'oe_favoritos';
  var MAX = 100;
  var cfg = window.oeWishConfig || {};
  var root = (cfg.root || '/').replace(/\/?$/, '/');
  var pageUrl = cfg.pageUrl || '/pages/favoritos';
  var memory = [];

  /* ---------- almacenamiento ---------- */
  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(list)) return [];
      return list.filter(function (x) { return x && typeof x.h === 'string' && x.h; });
    } catch (e) {
      return memory.slice();
    }
  }
  function write(list) {
    memory = list.slice(0, MAX);
    try { window.localStorage.setItem(KEY, JSON.stringify(memory)); } catch (e) {}
  }
  function has(handle) {
    return read().some(function (x) { return x.h === handle; });
  }
  function add(handle) {
    if (!handle || has(handle)) return;
    var list = read();
    list.unshift({ h: handle, t: Date.now() });
    write(list);
  }
  function remove(handle) {
    write(read().filter(function (x) { return x.h !== handle; }));
  }
  function handles() {
    return read().map(function (x) { return x.h; });
  }

  /* ---------- utilidades ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || cfg.moneyFormat || '${{amount_no_decimals}}';
    function fmt(n, dec, th, dc) {
      dec = dec == null ? 2 : dec;
      th = th || ',';
      dc = dc || '.';
      var num = (n / 100).toFixed(dec);
      var parts = num.split('.');
      var ints = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th);
      return ints + (parts[1] ? dc + parts[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (m ? m[1] : 'amount') {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = fmt(cents, 2, ' ', '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value).replace(/<[^>]*>/g, '');
  }

  /* ---------- aviso flotante ---------- */
  var toastEl, toastTimer;
  function toast(html, ms) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'oe-wish-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = html;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, ms || 3200);
  }

  /* ---------- Klaviyo ---------- */
  function track(d) {
    try {
      var payload = {
        ProductName: d.title,
        ProductID: d.id,
        ProductHandle: d.handle,
        URL: d.url,
        ImageURL: d.image,
        Price: d.price ? parseInt(d.price, 10) / 100 : undefined
      };
      if (window.klaviyo && typeof window.klaviyo.push === 'function') {
        window.klaviyo.push(['track', 'Agregó a Favoritos', payload]);
      } else {
        window._learnq = window._learnq || [];
        window._learnq.push(['track', 'Agregó a Favoritos', payload]);
      }
    } catch (e) {}
  }

  /* ---------- sincronizar corazones y contador ---------- */
  function sync() {
    var set = {};
    var list = handles();
    list.forEach(function (h) { set[h] = true; });
    document.querySelectorAll('[data-oe-wish]').forEach(function (btn) {
      var on = !!set[btn.getAttribute('data-oe-wish')];
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = on ? 'Quitar de favoritos' : 'Guardar en favoritos';
      btn.setAttribute('aria-label', label);
      btn.setAttribute('title', label);
    });
    document.querySelectorAll('[data-oe-wish-count]').forEach(function (el) {
      var n = list.length;
      var num = el.querySelector('[data-oe-wish-count-num]') || el;
      var txt = n > 99 ? '99+' : String(n);
      if (num.textContent !== txt) num.textContent = txt;
      if (el.hidden !== (n === 0)) el.hidden = n === 0;
    });
    document.querySelectorAll('.oe-wishlist-icon').forEach(function (el) {
      el.classList.toggle('has-items', list.length > 0);
    });
  }
  var syncQueued = false;
  function queueSync() {
    if (syncQueued) return;
    syncQueued = true;
    (window.requestAnimationFrame || setTimeout)(function () {
      syncQueued = false;
      decorate();
      sync();
    });
  }

  /* ---------- clic en corazones ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-oe-wish]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-oe-wish');
    if (has(handle)) {
      remove(handle);
      sync();
      toast('Quitado de tus favoritos · <button type="button" class="oe-wish-toast__link" data-oe-wish-undo="' + esc(handle) + '">Deshacer</button>');
    } else {
      add(handle);
      sync();
      btn.classList.remove('oe-wish-pop');
      void btn.offsetWidth;
      btn.classList.add('oe-wish-pop');
      track({
        handle: handle,
        id: btn.getAttribute('data-id'),
        title: btn.getAttribute('data-title'),
        url: btn.getAttribute('data-url'),
        image: btn.getAttribute('data-image'),
        price: btn.getAttribute('data-price')
      });
      toast('Guardado en tus favoritos · <a class="oe-wish-toast__link" href="' + esc(pageUrl) + '">Ver favoritos</a>');
    }
    document.dispatchEvent(new CustomEvent('oe:wishlist:change', { detail: { handles: handles() } }));
  }, true);

  document.addEventListener('click', function (e) {
    var undo = e.target.closest && e.target.closest('[data-oe-wish-undo]');
    if (!undo) return;
    e.preventDefault();
    add(undo.getAttribute('data-oe-wish-undo'));
    sync();
    if (toastEl) toastEl.classList.remove('is-visible');
    document.dispatchEvent(new CustomEvent('oe:wishlist:change', { detail: { handles: handles(), undo: true } }));
  });

  window.addEventListener('storage', function (e) {
    if (e.key === KEY) {
      sync();
      document.dispatchEvent(new CustomEvent('oe:wishlist:change', { detail: { handles: handles() } }));
    }
  });

  /* ==========================================================================
     Página "Mis favoritos"
     ========================================================================== */
  var cache = {};
  function fetchProduct(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return cache[handle];
  }

  function imgUrl(src, width) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function variantChoices(p) {
    var opts = p.options || [];
    var sizeIdx = -1;
    opts.forEach(function (o, i) {
      var name = (o && o.name ? o.name : String(o)).toLowerCase();
      if (sizeIdx === -1 && /talla|size|tamaño/.test(name)) sizeIdx = i;
    });
    var othersSingle = opts.every(function (o, i) {
      return i === sizeIdx || !o.values || o.values.length <= 1;
    });
    return (p.variants || []).map(function (v) {
      var label;
      if (opts.length <= 1) label = v.option1 || v.title;
      else if (sizeIdx > -1 && othersSingle) label = v['option' + (sizeIdx + 1)];
      else label = v.title;
      return { id: v.id, label: label, available: v.available, price: v.price, compare: v.compare_at_price };
    });
  }

  function cardHTML(p, shared) {
    var url = root + 'products/' + p.handle;
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var img2 = p.images && p.images[1] ? p.images[1] : '';
    var choices = variantChoices(p);
    var single = choices.length === 1 && (/default/i.test(choices[0].label) || choices[0].label === p.title);
    var anyAvailable = p.available;
    var compare = p.compare_at_price && p.compare_at_price > p.price ? p.compare_at_price : 0;

    var sizes = '';
    if (!single && choices.length) {
      sizes = '<div class="oe-fav__sizes" role="group" aria-label="Elige tu talla">' +
        choices.map(function (c) {
          return '<button type="button" class="oe-fav__size" data-variant="' + c.id + '"' +
            (c.available ? '' : ' disabled aria-disabled="true" title="Agotado"') + '>' + esc(c.label) + '</button>';
        }).join('') + '</div>';
    }

    var btnLabel = !anyAvailable ? 'Agotado' : (single ? 'Agregar al carrito' : 'Elige tu talla');
    var btnVariant = single && choices[0] ? ' data-variant="' + choices[0].id + '"' : '';
    var btnDisabled = !anyAvailable || !single ? ' disabled' : '';

    return '' +
      '<article class="oe-fav" data-handle="' + esc(p.handle) + '">' +
        '<div class="oe-fav__media">' +
          '<a href="' + url + '" class="oe-fav__media-link" tabindex="-1" aria-hidden="true">' +
            (img ? '<img src="' + imgUrl(img, 600) + '" srcset="' + imgUrl(img, 360) + ' 360w, ' + imgUrl(img, 600) + ' 600w, ' + imgUrl(img, 900) + ' 900w" sizes="(min-width: 990px) 25vw, 50vw" alt="' + esc(p.title) + '" loading="lazy" width="600" height="750">' : '') +
            (img2 ? '<img class="oe-fav__img2" src="' + imgUrl(img2, 600) + '" alt="" loading="lazy" width="600" height="750">' : '') +
          '</a>' +
          (!anyAvailable ? '<span class="oe-fav__badge">Agotado</span>' : (compare ? '<span class="oe-fav__badge">Oferta</span>' : '')) +
          '<button type="button" class="oe-wish-btn oe-wish-btn--card' + (shared ? '' : ' is-active') + '" data-oe-wish="' + esc(p.handle) + '" data-id="' + p.id + '" data-title="' + esc(p.title) + '" data-url="' + esc(location.origin + url) + '" data-image="' + esc(imgUrl(img, 600)) + '" data-price="' + p.price + '" aria-pressed="' + (shared ? 'false' : 'true') + '" aria-label="' + (shared ? 'Guardar en favoritos' : 'Quitar de favoritos') + '">' +
            '<svg class="oe-wish-btn__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.3s-7.8-4.6-7.8-10.2A4.4 4.4 0 0 1 12 7.4a4.4 4.4 0 0 1 7.8 2.7c0 5.6-7.8 10.2-7.8 10.2Z" stroke-linejoin="round"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="oe-fav__info">' +
          '<a href="' + url + '" class="oe-fav__title">' + esc(p.title) + '</a>' +
          '<p class="oe-fav__price">' +
            (compare ? '<s class="oe-fav__compare">' + esc(formatMoney(compare)) + '</s> ' : '') +
            '<span>' + (p.price_varies ? 'Desde ' : '') + esc(formatMoney(p.price)) + '</span>' +
          '</p>' +
          sizes +
          '<button type="button" class="button button--primary oe-fav__add"' + btnVariant + btnDisabled + '>' + btnLabel + '</button>' +
          '<p class="oe-fav__error" hidden></p>' +
        '</div>' +
      '</article>';
  }

  function initPage(el) {
    if (el.__oeInit) return;
    el.__oeInit = true;

    var grid = el.querySelector('[data-oe-wish-grid]');
    var empty = el.querySelector('[data-oe-wish-empty]');
    var countEl = el.querySelector('[data-oe-wish-page-count]');
    var actions = el.querySelector('[data-oe-wish-actions]');
    var sharedBar = el.querySelector('[data-oe-wish-shared]');
    var loading = el.querySelector('[data-oe-wish-loading]');

    var params = new URLSearchParams(location.search);
    var sharedParam = params.get('lista');
    var shared = sharedParam
      ? sharedParam.split(',').map(function (s) { return s.trim(); }).filter(Boolean).slice(0, MAX)
      : null;

    if (shared && sharedBar) sharedBar.hidden = false;

    function setCount(n) {
      if (!countEl) return;
      countEl.textContent = n === 0 ? '' : (n === 1 ? '1 prenda guardada' : n + ' prendas guardadas');
    }

    function render() {
      var list = shared || handles();
      if (loading) loading.hidden = list.length === 0;
      if (!list.length) {
        grid.innerHTML = '';
        grid.hidden = true;
        if (empty) empty.hidden = false;
        if (actions) actions.hidden = true;
        setCount(0);
        return;
      }
      if (empty) empty.hidden = true;
      Promise.all(list.map(fetchProduct)).then(function (products) {
        var valid = [];
        products.forEach(function (p, i) {
          if (p && p.handle) valid.push(p);
          else if (!shared) remove(list[i]);
        });
        if (loading) loading.hidden = true;
        if (!valid.length) {
          grid.innerHTML = '';
          grid.hidden = true;
          if (empty) empty.hidden = false;
          if (actions) actions.hidden = true;
          setCount(0);
          sync();
          return;
        }
        grid.hidden = false;
        grid.innerHTML = valid.map(function (p) { return cardHTML(p, !!shared); }).join('');
        if (actions) actions.hidden = !!shared;
        setCount(valid.length);
        sync();
      });
    }

    /* elegir talla */
    grid.addEventListener('click', function (e) {
      var size = e.target.closest('.oe-fav__size');
      if (size && !size.disabled) {
        var card = size.closest('.oe-fav');
        card.querySelectorAll('.oe-fav__size').forEach(function (b) {
          b.classList.toggle('is-selected', b === size);
          b.setAttribute('aria-pressed', b === size ? 'true' : 'false');
        });
        var btn = card.querySelector('.oe-fav__add');
        btn.disabled = false;
        btn.setAttribute('data-variant', size.getAttribute('data-variant'));
        btn.textContent = 'Agregar al carrito';
        return;
      }
      var addBtn = e.target.closest('.oe-fav__add');
      if (addBtn && !addBtn.disabled) addToCart(addBtn);
    });

    function addToCart(btn) {
      var id = btn.getAttribute('data-variant');
      if (!id) return;
      var card = btn.closest('.oe-fav');
      var err = card.querySelector('.oe-fav__error');
      var cartDrawer = document.querySelector('cart-drawer');
      var body = { id: parseInt(id, 10), quantity: 1 };
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        body.sections = 'cart-drawer,cart-icon-bubble';
        body.sections_url = location.pathname;
      }
      btn.disabled = true;
      btn.classList.add('loading');
      var original = btn.textContent;
      btn.textContent = 'Agregando…';
      if (err) err.hidden = true;

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
        .then(function (res) {
          btn.classList.remove('loading');
          if (!res.ok || res.data.status) {
            btn.disabled = false;
            btn.textContent = original;
            if (err) {
              err.textContent = res.data.description || res.data.message || 'No pudimos agregar esta prenda. Intenta de nuevo.';
              err.hidden = false;
            }
            return;
          }
          btn.textContent = '¡Agregado!';
          setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2000);
          if (cartDrawer && res.data.sections) {
            cartDrawer.classList.remove('is-empty');
            cartDrawer.renderContents(res.data);
          } else {
            window.location.href = root + 'cart';
          }
        })
        .catch(function () {
          btn.classList.remove('loading');
          btn.disabled = false;
          btn.textContent = original;
          if (err) { err.textContent = 'No pudimos agregar esta prenda. Intenta de nuevo.'; err.hidden = false; }
        });
    }

    /* compartir mi lista */
    var shareBtn = el.querySelector('[data-oe-wish-share]');
    if (shareBtn) {
      shareBtn.addEventListener('click', function () {
        var link = location.origin + pageUrl + '?lista=' + handles().map(encodeURIComponent).join(',');
        if (navigator.share) {
          navigator.share({ title: 'Mis favoritos de oé', text: 'Mira las prendas que me encantan de oé', url: link }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(link).then(function () { toast('Link copiado. ¡Compártelo con quien quieras!'); });
        } else {
          window.prompt('Copia este link:', link);
        }
      });
    }

    /* guardar lista compartida */
    var saveAll = el.querySelector('[data-oe-wish-save-all]');
    if (saveAll && shared) {
      saveAll.addEventListener('click', function () {
        shared.slice().reverse().forEach(add);
        sync();
        toast('Listo, se guardaron en tus favoritos · <a class="oe-wish-toast__link" href="' + esc(pageUrl) + '">Ver mis favoritos</a>');
      });
    }

    /* si quita un corazón en la página, desaparece la prenda */
    document.addEventListener('oe:wishlist:change', function () {
      if (shared) return;
      var current = handles();
      var shown = Array.prototype.map.call(grid.querySelectorAll('.oe-fav'), function (c) { return c.getAttribute('data-handle'); });
      var removed = shown.filter(function (h) { return current.indexOf(h) === -1; });
      var added = current.filter(function (h) { return shown.indexOf(h) === -1; });
      if (added.length) { render(); return; }
      removed.forEach(function (h) {
        var c = grid.querySelector('.oe-fav[data-handle="' + (window.CSS && CSS.escape ? CSS.escape(h) : h) + '"]');
        if (c) {
          c.classList.add('is-removing');
          setTimeout(function () { if (c.parentNode) c.parentNode.removeChild(c); if (!grid.children.length) render(); }, 280);
        }
      });
      setCount(current.length);
    });

    render();
  }

  /* ==========================================================================
     Corazones automáticos en tarjetas y en la ficha de producto
     (se insertan por JS para no tocar los archivos grandes del tema)
     ========================================================================== */
  var HEART = '<svg class="oe-wish-btn__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M12 20.3s-7.8-4.6-7.8-10.2A4.4 4.4 0 0 1 12 7.4a4.4 4.4 0 0 1 7.8 2.7c0 5.6-7.8 10.2-7.8 10.2Z" stroke-linejoin="round"/></svg>';

  function priceToCents(text) {
    var digits = String(text || '').replace(/[^\d]/g, '');
    if (!digits) return '';
    var noDecimals = /no_decimals/.test(cfg.moneyFormat || '');
    return String(noDecimals ? parseInt(digits, 10) * 100 : parseInt(digits, 10));
  }

  function makeButton(data, ctx) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'oe-wish-btn oe-wish-btn--' + ctx;
    btn.setAttribute('data-oe-wish', data.handle);
    if (data.id) btn.setAttribute('data-id', data.id);
    if (data.title) btn.setAttribute('data-title', data.title);
    if (data.url) btn.setAttribute('data-url', data.url);
    if (data.image) btn.setAttribute('data-image', data.image);
    if (data.price) btn.setAttribute('data-price', data.price);
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('aria-label', 'Guardar en favoritos');
    btn.setAttribute('title', 'Guardar en favoritos');
    btn.innerHTML = HEART;
    return btn;
  }

  function decorateCards() {
    if (cfg.cards === false) return;
    document.querySelectorAll('.card-wrapper').forEach(function (w) {
      if (w.__oeWish || w.closest('[data-oe-wish-page]') || w.closest('predictive-search')) return;
      var card = w.querySelector('.card');
      var link = w.querySelector('a[href*="/products/"]');
      if (!card || !link) return;
      var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!m) return;
      w.__oeWish = true;
      if (card.querySelector('[data-oe-wish]')) return;
      var handle = decodeURIComponent(m[1]);
      var img = w.querySelector('.card__media img');
      var priceEl = w.querySelector('.price-item--sale') || w.querySelector('.price-item--regular');
      var btn = makeButton({
        handle: handle,
        title: (link.textContent || '').trim(),
        url: location.origin + root + 'products/' + handle,
        image: img ? (img.currentSrc || img.src || '') : '',
        price: priceEl ? priceToCents(priceEl.textContent) : ''
      }, 'card');
      card.appendChild(btn);
    });
  }

  function decorateProduct() {
    var p = cfg.product;
    if (!p || !p.handle) return;
    var title = document.querySelector('[id^="MainProduct-"] .product__title');
    if (!title || title.__oeWish || title.closest('.quick-add-modal')) return;
    title.__oeWish = true;
    if (title.querySelector('[data-oe-wish]')) return;
    title.classList.add('oe-wish-title');
    var h1 = title.querySelector('h1');
    var btn = makeButton(p, 'product');
    if (h1 && h1.nextSibling) title.insertBefore(btn, h1.nextSibling);
    else title.appendChild(btn);
  }

  function decorateHeader() {
    document.querySelectorAll('.oe-wishlist-icon').forEach(function (a) {
      if (a.querySelector('[data-oe-wish-count]')) return;
      var c = document.createElement('span');
      c.className = 'oe-wish-count';
      c.setAttribute('data-oe-wish-count', '');
      c.setAttribute('aria-hidden', 'true');
      c.hidden = true;
      c.innerHTML = '<span data-oe-wish-count-num>0</span>';
      a.appendChild(c);
      if (/swym/.test(a.getAttribute('href') || '')) a.setAttribute('href', pageUrl);
    });
  }

  function decorate() {
    decorateHeader();
    decorateCards();
    decorateProduct();
  }

  /* ---------- arranque ---------- */
  function boot() {
    decorate();
    sync();
    document.querySelectorAll('[data-oe-wish-page]').forEach(initPage);
    if ('MutationObserver' in window) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes && muts[i].addedNodes.length) { queueSync(); break; }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', function () {
      decorate();
      sync();
      document.querySelectorAll('[data-oe-wish-page]').forEach(initPage);
    });
  }

  window.oeWishlist = { list: handles, has: has, add: function (h) { add(h); sync(); }, remove: function (h) { remove(h); sync(); }, sync: sync };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
